var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-theme",
    { attrs: { "md-name": "blue" } },
    [
      _c("breadcrumbs", { attrs: { section: "Partner integrations" } }),
      _c(
        "md-layout",
        { attrs: { "md-flex": "100", "md-align": "center" } },
        [
          _c(
            "md-layout",
            { attrs: { "md-flex": "60", "md-flex-small": "100" } },
            [
              _c(
                "md-whiteframe",
                {
                  staticClass: "form-wrapper-frame",
                  attrs: { "md-elevation": "3" }
                },
                [
                  _c(
                    "md-layout",
                    { attrs: { "md-flex": "100" } },
                    [
                      _c(
                        "md-layout",
                        {
                          staticClass: "test",
                          attrs: {
                            "md-flex": "100",
                            "md-flex-small": "100",
                            "md-vertical-align": "center",
                            "md-align": "center"
                          }
                        },
                        [
                          _c("div", { staticClass: "turn-off-google-info" }, [
                            _c("div", [
                              _c("h4", [_vm._v("Want a Roku channel?")]),
                              _c("span", [_vm._v("Roku developer")]),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    href: "https://developer.roku.com/"
                                  }
                                },
                                [_vm._v("sign up")]
                              ),
                              _c("p", [
                                _c("span", [
                                  _vm._v("Rhebus TV can also run this for you,")
                                ]),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      target: "_blank",
                                      rel: "noopener noreferrer",
                                      href:
                                        "mailto:info@rhebus.works?Subject=Roku%20Channel%20Dev"
                                    }
                                  },
                                  [_vm._v("please get in touch")]
                                )
                              ])
                            ]),
                            _c("div", [
                              _c("h4", [_vm._v("Want an Amazon FireTV App?")]),
                              _c("span", [_vm._v(" Amazon FireTV developer")]),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    href:
                                      "https://developer.amazon.com/apps-and-games/console/app/list"
                                  }
                                },
                                [_vm._v("sign up")]
                              ),
                              _c("p", [
                                _c("span", [
                                  _vm._v("Rhebus TV can also run this for you,")
                                ]),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      target: "_blank",
                                      rel: "noopener noreferrer",
                                      href:
                                        "mailto:info@rhebus.works?Subject=Amazon%20App%20Dev"
                                    }
                                  },
                                  [_vm._v("please get in touch")]
                                )
                              ])
                            ]),
                            _c("div", [
                              _c("h4", [
                                _vm._v("Want more users for your Roku Channel?")
                              ]),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    href: "https://admanager.roku.com/login"
                                  }
                                },
                                [_vm._v("Roku User Acquisition")]
                              ),
                              _c("p", [
                                _c("span", [
                                  _vm._v("Rhebus TV can also run this for you,")
                                ]),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      target: "_blank",
                                      rel: "noopener noreferrer",
                                      href:
                                        "mailto:info@rhebus.works?Subject=Roku%20UA"
                                    }
                                  },
                                  [_vm._v("please get in touch")]
                                )
                              ])
                            ]),
                            _c("div", [
                              _c("h4", [
                                _vm._v(
                                  "Need subtitles or closed captions for your video?"
                                )
                              ]),
                              _c("p", [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      target: "_blank",
                                      rel: "noopener noreferrer",
                                      href: "https://www.3playmedia.com"
                                    }
                                  },
                                  [_vm._v("3Play Media")]
                                )
                              ]),
                              _c("p", [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      target: "_blank",
                                      rel: "noopener noreferrer",
                                      href: "https://dotsub.com"
                                    }
                                  },
                                  [_vm._v("Dotsub")]
                                )
                              ]),
                              _c("p", [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      target: "_blank",
                                      rel: "noopener noreferrer",
                                      href:
                                        "http://main.wgbh.org/wgbh/pages/mag/services/captioning"
                                    }
                                  },
                                  [_vm._v("Media Access Group WGBH-TV")]
                                )
                              ]),
                              _c("p", [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      target: "_blank",
                                      rel: "noopener noreferrer",
                                      href: "https://rev.com"
                                    }
                                  },
                                  [_vm._v("Rev")]
                                )
                              ]),
                              _c("p", [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      target: "_blank",
                                      rel: "noopener noreferrer",
                                      href: "http://www.subply.com"
                                    }
                                  },
                                  [_vm._v("SubPly")]
                                )
                              ]),
                              _c("p", [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      target: "_blank",
                                      rel: "noopener noreferrer",
                                      href: "https://visualdatamedia.com"
                                    }
                                  },
                                  [_vm._v("Visual Data Media")]
                                )
                              ])
                            ])
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _c("div", { staticClass: "imgContainer" }, [
                    _c("img", {
                      attrs: {
                        src: require("../../assets/img/RhebusTV_logo.jpg")
                      }
                    })
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-670263cd", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-670263cd","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/spa/partnerIntegrations/Profile.vue
// module id = 698
// module chunks = 0